import { logRBIEvent } from 'features/analytics';
import { AllowedEvent } from 'features/analytics/allowed-events';
import { CustomEventNames, EventTypes } from 'features/analytics/constants';
import { IAmplitudeProduct } from 'features/analytics/types';
import logger from 'features/observability/logger';

const convertToSingleCommerceProduct = (product: Partial<IAmplitudeProduct>) => {
  const { id, quantity, name, price, total_product_amount, ...rest } = product;
  return {
    ...rest,
    Quantity: String(quantity),
    Id: String(id),
    Name: String(name),
    'Total Product Amount': String(total_product_amount),
    Price: String(price),
  };
};

export const buildCommercePageViewEvents = (
  menuData: { id: string; name: string; menuType: string },
  attrs: Record<string, unknown> = {}
) => {
  const { name, id, menuType } = menuData;
  const product = { id, name, quantity: 1, price: 0, total_product_amount: 0 };
  const singleProduct = convertToSingleCommerceProduct(product);

  return [
    {
      name: CustomEventNames.E_COMMERCE_VIEW_DETAIL,
      type: EventTypes.Other,
      attributes: { menuType, ...attrs, products: [product] },
    } as AllowedEvent,
    {
      name: 'eCommerce - ViewDetail - Item',
      type: EventTypes.Other,
      attributes: { menuType, products: [], ...singleProduct, ...attrs },
    } as AllowedEvent,
  ];
};

export const logCommercePageView = (
  menuData: Parameters<typeof buildCommercePageViewEvents>[0],
  attrs: Parameters<typeof buildCommercePageViewEvents>[1] = {}
) => {
  try {
    buildCommercePageViewEvents(menuData, attrs).forEach(event => logRBIEvent(event));
  } catch (error) {
    logger.error({ error, message: 'Error logging CRM eCommerce - View Detail event' });
  }
};
